import { render } from "./SettingsMail.vue?vue&type=template&id=aea0d14c&scoped=true"
import script from "./SettingsMail.vue?vue&type=script&lang=js"
export * from "./SettingsMail.vue?vue&type=script&lang=js"

import "./SettingsMail.vue?vue&type=style&index=0&id=aea0d14c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aea0d14c"]])

export default __exports__